module.exports = __webpack_public_path__ + "static/img/VaccinationHis.8f502b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon/VaccinationHis.jpg
// module id = M65T
// module chunks = 2